// AUTOGENERATED
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dAnalytics$dTypes$dChosenSuggestion from "../Restaumatic.Analytics.Types.ChosenSuggestion/index.js";
import * as Restaumatic$dAnalytics$dTypes$dItemList from "../Restaumatic.Analytics.Types.ItemList/index.js";
import * as Restaumatic$dAnalytics$dTypes$dShownSuggestion from "../Restaumatic.Analytics.Types.ShownSuggestion/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const eq = /* #__PURE__ */ (() => Data$dEq.eqArrayImpl(Restaumatic$dAnalytics$dTypes$dChosenSuggestion.eqChosenSuggestion.eq))();
const eq2 = /* #__PURE__ */ Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl);
const eq4 = /* #__PURE__ */ (() => Data$dEq.eqArrayImpl(Restaumatic$dAnalytics$dTypes$dShownSuggestion.eqShownSuggestion.eq))();
const chosenSuggestionsIsSymbol = {reflectSymbol: () => "chosenSuggestions"};
const listIsSymbol = {reflectSymbol: () => "list"};
const mainProductsIsSymbol = {reflectSymbol: () => "mainProducts"};
const restaurantIdIsSymbol = {reflectSymbol: () => "restaurantId"};
const shownSuggestionsIsSymbol = {reflectSymbol: () => "shownSuggestions"};
const SuggestionResultIsSymbol = {reflectSymbol: () => "SuggestionResult"};
const SuggestionResult = x => x;
const toFillFormTypeSuggestionR = {fillFormDataType: v => "unknown"};
const newtypeSuggestionResult_ = {Coercible0: () => {}};
const hasFieldSuggestionResult = dictHasField => dictHasField;
const eqSuggestionResult = {
  eq: x => y => eq(x.chosenSuggestions)(y.chosenSuggestions) && (() => {
    if (x.list.tag === "Menu") { return y.list.tag === "Menu"; }
    if (x.list.tag === "CreatorCrossSelling") { return y.list.tag === "CreatorCrossSelling"; }
    if (x.list.tag === "CartCrossSelling") { return y.list.tag === "CartCrossSelling"; }
    return false;
  })() && eq2(x.mainProducts)(y.mainProducts) && x.restaurantId === y.restaurantId && eq4(x.shownSuggestions)(y.shownSuggestions)
};
const genericSuggestionResult = {to: x => x, from: x => x};
const showSuggestionResult = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(Restaumatic$dAnalytics$dTypes$dShownSuggestion.showShownSuggestion.show);
      const $1 = Data$dShow.showArrayImpl(Data$dUUID.toString);
      const $2 = Data$dShow.showArrayImpl(Restaumatic$dAnalytics$dTypes$dChosenSuggestion.showChosenSuggestion.show);
      return {
        genericShowArgs: v => [
          "{ chosenSuggestions: " + $2(v.chosenSuggestions) + ", list: " + Restaumatic$dAnalytics$dTypes$dItemList.showItemList.show(v.list) + ", mainProducts: " + $1(v.mainProducts) + ", restaurantId: " + Data$dShow.showIntImpl(v.restaurantId) + ", shownSuggestions: " + $0(v.shownSuggestions) + " " + "}"
        ]
      };
    })())(SuggestionResultIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeSuggestionResult = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(chosenSuggestionsIsSymbol)({
      unsafeDecode: Unscramble.decodeArray(Restaumatic$dAnalytics$dTypes$dChosenSuggestion.unscrambleDecodeChosenSuggestion.unsafeDecode)
    })(Unscramble.decodeRecordCons(listIsSymbol)(Restaumatic$dAnalytics$dTypes$dItemList.unscrambleDecodeItemList)(Unscramble.decodeRecordCons(mainProductsIsSymbol)({
      unsafeDecode: Unscramble.decodeArray(Data$dUUID.udecodeUUID.unsafeDecode)
    })(Unscramble.decodeRecordCons(restaurantIdIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordCons(shownSuggestionsIsSymbol)({
      unsafeDecode: Unscramble.decodeArray(Restaumatic$dAnalytics$dTypes$dShownSuggestion.unscrambleDecodeShownSuggestion.unsafeDecode)
    })(Unscramble.decodeRecordNil))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeSuggestionResult = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericSuggestionResult)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(SuggestionResultIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(shownSuggestionsIsSymbol)((() => {
      const encode1 = Data$dFunctor.arrayMap(Restaumatic$dAnalytics$dTypes$dShownSuggestion.encodeShownSuggestion.encode);
      return {encodeWithOptions: v => encode1};
    })()))(restaurantIdIsSymbol)({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))(mainProductsIsSymbol)((() => {
      const encode1 = Data$dFunctor.arrayMap(Data$dUUID.encodeUUID.encode);
      return {encodeWithOptions: v => encode1};
    })()))(listIsSymbol)({encodeWithOptions: v => Restaumatic$dAnalytics$dTypes$dItemList.encodeItemList.encode}))(chosenSuggestionsIsSymbol)((() => {
      const encode1 = Data$dFunctor.arrayMap(Restaumatic$dAnalytics$dTypes$dChosenSuggestion.encodeChosenSuggestion.encode);
      return {encodeWithOptions: v => encode1};
    })());
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeSuggestionResult = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericSuggestionResult)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(SuggestionResultIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(shownSuggestionsIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Foreign$dGeneric$dClass.arrayDecode(Restaumatic$dAnalytics$dTypes$dShownSuggestion.decodeShownSuggestion).decode;
    return {decodeWithOptions: v => decode2};
  })())())(restaurantIdIsSymbol)({decodeWithOptions: v => Foreign$dGeneric$dClass.intDecode.decode})())(mainProductsIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Foreign$dGeneric$dClass.arrayDecode(Data$dUUID.decodeUUID).decode;
    return {decodeWithOptions: v => decode2};
  })())())(listIsSymbol)({decodeWithOptions: v => Restaumatic$dAnalytics$dTypes$dItemList.decodeItemList.decode})())(chosenSuggestionsIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Foreign$dGeneric$dClass.arrayDecode(Restaumatic$dAnalytics$dTypes$dChosenSuggestion.decodeChosenSuggestion).decode;
    return {decodeWithOptions: v => decode2};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  SuggestionResult,
  SuggestionResultIsSymbol,
  chosenSuggestionsIsSymbol,
  decodeSuggestionResult,
  encodeSuggestionResult,
  eq,
  eq2,
  eq4,
  eqSuggestionResult,
  genericSuggestionResult,
  hasFieldSuggestionResult,
  listIsSymbol,
  mainProductsIsSymbol,
  newtypeSuggestionResult_,
  restaurantIdIsSymbol,
  showSuggestionResult,
  shownSuggestionsIsSymbol,
  toFillFormTypeSuggestionR,
  unscrambleDecodeSuggestionResult
};
